import DataUtils from "./utils/DataUtils";
/**
 * 按照路由配置规则，初始化一些默认参数，
 * @param routers
 */
export function initAuthRouters(routers) {
  for (let router of routers) {
      if(router.children){
        let parentPath = router.path;
        for (let child of router.children){
          if (parentPath === '/'){
            child.fullPath = `${parentPath}${child.path}`;
          }else{
            child.fullPath = `${parentPath}/${child.path}`;
          }
        }
      }
  }
  return routers;
}


/**
 * 根据服务器设置路由title
 * @param routers
 */
export function setRouterTitle(routers, menuRouters) {
  menuRouters.forEach((menuRouter) => {
    let router = DataUtils.breadthTreeQuery(routers, 'name', menuRouter.routeUrl);
    if (router){
      router.title = menuRouter.name;
      if (router.meta){
        router.meta.title = menuRouter.name // '资源管理-' +
      }
    }
  });

  return routers;
}



// WEBPACK FOOTER //
// ./src/libs/combineAuthRouters.js